import type { SelectorDateTimeWithControlProps } from '../SelectorDateTime';
import { SelectorDateTimeWithControl } from '../SelectorDateTime';

export type SelectorDateWithControlProps = Omit<
	SelectorDateTimeWithControlProps,
	'dateOnly'
>;

export function SelectorDateWithControl(props: SelectorDateWithControlProps) {
	return <SelectorDateTimeWithControl {...props} dateOnly />;
}
